import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
} from "react-native";
import Text from "app/components/Text";
import Value from "app/components/Value";
import ValueInput from "app/components/ValueInput";
import Generation from "app/components/Generation";
import Canvas from "app/components/Canvas";
import apiActions from "app/utils/apiActions";
import storageActions from "app/utils/storageActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import { styleSheet, colors, sizes } from "app/utils/styleSheet";

import Hoverable from "app/components/Hoverable";

import {
  Ionicons,
  Octicons,
  FontAwesome,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

const WEB = Platform.OS == "web";

export default class Today extends React.Component {
  static navigationOptions = ({
    navigation,
    navigationOptions,
    screenProps,
  }) => {
    return {
      headerShown: false,
    };
  };

  static propTypes = {
    screenProps: PropTypes.shape({
      // values: PropTypes.arrayOf(PropTypes.object),
    }),
  };

  constructor(props) {
    super(props);
    // let { user } = props.screenProps
    // props.navigation
    this.state = {
      values: [],
      allValues: [],
      fetching: true,
      query: "",
      hideComplete: true,
      fromBottom: true,
      showOnlyStarred: false,
      showNotes: true,
      showSnoozed: 0,
      showDoneToday: 1,
      familyIds: [],
      selectedValue: null,
      lines: [],
      quickActionsId: null,
      enableBlur: true,
      redrawKey: 0,
    };

    let { navigation, route } = this.props;
    navigation.setOptions({
      headerRight: () => (
        <TouchableOpacity onPress={navigation.toggleDrawer}>
          <Ionicons
            name="ios-menu"
            size={32}
            color={colors.foreground}
            style={{ marginRight: 20 }}
          />
        </TouchableOpacity>
      ),
    });
  }

  async componentDidMount() {
    this.fetch();
    this._unsubscribe = this.props.navigation.addListener("focus", () => {
      this.fetch();
    });
    let allValues = await storageActions.fetchItem("values");
    this.setState({ allValues });
  }

  componentWillUnmount() {
    if (this._unsubscribe) this._unsubscribe();
  }

  fetch = async () => {
    this.setState({ fetching: true });
    console.log("today fetch...");
    let ids = [];
    let data = { level: 0, lite: true, ids };
    let values = await apiActions.request("values", "GET", data);
    // console.log(values)
    if (!!values) {
      values = valueHelpers.applyColors(values);
      this.setState({ values, fetching: false });
    } else console.warn("error", values);
  };

  render() {
    let { navigation } = this.props;
    let { values, fetching } = this.state;

    return (
      <View style={styles.container}>
        <StatusBar style="auto" />

        {fetching && <ActivityIndicator />}

        {this.renderValues()}

        <View />
      </View>
    );
  }

  renderValues = () => {
    let { navigation } = this.props;
    let { values, fetching, quickActionsId, selectedValue, allValues } =
      this.state;
    values = values.filter(
      (v) => v.level == 0 && !v.completed_at && !valueHelpers.isSnoozed(v),
    );
    values = textHelpers.newestFirst(values, "updated_at");

    return (
      <ScrollView style={{ flex: 1 }}>
        <View style={[styles.row]}>
          <View style={styles.rowContent}>
            {values.map((v, i) => {
              let value = allValues.find((val) => val.id == v.id) || v;
              return (
                <Hoverable
                  onHoverIn={() => this.hoverIn(value)}
                  onHoverOut={() => this.hoverOut(value)}
                  key={i}
                >
                  {(isHovered) => {
                    let selected =
                      !!selectedValue && selectedValue.id == value.id;
                    // let selected = familyIds.includes(value.id)
                    return (
                      <View
                        style={
                          {
                            // transform: [{
                            //   scale: scalePerc,
                            // }],
                            // opacity: isHovered || familyIds.includes(value.id) ? 1 : (
                            //   !!familyIds.length && !familyIds.includes(value.id) ? Math.min(opacityPerc,0.5) : opacityPerc
                            // ),
                          }
                        }
                      >
                        <Value
                          circle
                          value={value}
                          key={`value-${value.id}`}
                          ref={(ref) => {
                            this[`val_${value.id}`] = ref;
                          }}
                          selected={selected}
                          blur={true}
                          // onLongPress={() => selectedValue == value ? this.hoverOut(value) : this.hoverIn(value)}
                          // onPressIn={() => this.hoverIn(value)}
                          // onPressOut={() => this.hoverOut(value)}
                          onDeselect={() => this.hoverOut(value)}
                          onPress={() => {
                            // if(selected){
                            navigation.navigate("Value", {
                              value,
                              id: value.id,
                            });
                            // }
                            // else {
                            //   this.hoverIn(value)
                            // }
                          }}
                          style={[
                            styles.itemStyle,
                            // isHovered || i<7 || familyIds.includes(value.id) ? null : {
                            isHovered || i < 7
                              ? null
                              : {
                                  transform: [
                                    {
                                      scale: 0.9 - 0.025 * (i - 6),
                                    },
                                  ],
                                  //   // opacity: (0.9 - (0.025*(i-6))),
                                },
                            // familyIds.includes(value.id) ? {borderColor: colors.active} : null,
                          ]}
                          maxWidth={250}
                          filterToFamily={() =>
                            this.handleFilterToFamily(value)
                          }
                          onUpdate={(val) => {
                            let newAllValues = allValues.map((v) =>
                              v.id == val.id ? { ...v, ...val } : v,
                            );
                            storageActions.saveItem("values", newAllValues);
                            let newValues = values.map((v) =>
                              v.id == val.id ? { ...v, ...val } : v,
                            );
                            newValues = textHelpers.newestFirst(
                              newValues,
                              "updated_at",
                            );
                            this.setState({
                              values: newValues,
                              allValues: newAllValues,
                              query: "",
                            });
                          }}
                          showQuickActions={quickActionsId == value.id}
                          onShowQuickActions={() =>
                            this.setState({ quickActionsId: value.id })
                          }
                          onHideQuickActions={() =>
                            this.setState({ quickActionsId: null })
                          }
                        />
                      </View>
                    );
                  }}
                </Hoverable>
              );
            })}
          </View>
        </View>
      </ScrollView>
    );
  };

  handleClickValue = (value) => {
    let { values } = this.state;
    value.clicked = true;
    values.map((v) => (v.id == value.id ? value : v));
    this.setState({ values });
  };

  hoverIn = (value) => {
    let { values } = this.state;
    let familyIds = [value.id];
  };

  hoverOut = (value = null) => {
    this.setState({ familyIds: [], selectedValue: null, lines: [] });
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-around",
    // backgroundColor: '#111',
  },
  row: {
    flexGrow: 1,
    borderColor: colors.trim,
    // borderBottomWidth: 1,
    alignSelf: "stretch",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: sizes.large,
  },
  rowScroller: {
    flexGrow: 0,
    // flex: 1,
    alignSelf: "stretch",
    flexDirection: "row",
    // padding: 10,
    paddingBottom: sizes.large,
    flexWrap: "wrap",
  },
  rowContainer: {
    flexGrow: 1,
    flexDirection: "row",
    justifyContent: "space-around",
    justifyContent: "center",
    alignSelf: "center",
    // margin: 10,
  },
  rowContent: {
    // borderWidth: 1, borderColor: 'white',
    // flex: -1,
    flex: 1,
    flexDirection: "row",
    alignSelf: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    paddingLeft: sizes.base,
  },
  itemStyle: {
    maxWidth: WEB ? 250 : 100,
    marginBottom: 5,
    // flexDirection: 'row',
    // flexWrap: 'nowrap',
    // alignItems: 'center',

    // marginRight: 10,
    // marginTop: 5,
    // padding: 5,
    // backgroundColor: '#111',
  },
  queryRow: {
    flexGrow: 0,
    height: 50,
    padding: sizes.base,
    justifyContent: "flex-start",
  },
  input: {
    ...styleSheet.input,
    alignSelf: "stretch",
    flex: 1,
  },
  icon: {
    marginLeft: sizes.base,
    minWidth: sizes.base,
  },
});
